import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unableloginvendor',
  templateUrl: './unableloginvendor.component.html',
  styleUrls: ['./unableloginvendor.component.scss']
})
export class UnableloginvendorComponent {

  constructor(private router: Router) { }

  login = {
    email: 'rajhans@yopmail.com'
  };


  onSubmit() {
    if (this.login.email) {
      this.router.navigate(['/vendor-login']);
    } else {
      alert('Please enter a valid email!');
    }
  }

}
